import { useState, useEffect }  from 'react';
import {
    Main,
    ApplicationFooter,
    Slider,
    ApplicationWrapper,
    ApplicationHeader,
    ApplicationContent,
    Permissions
}                               from './components';
import AuthorizationContext     from 'auth/keycloak-instance';
import { Link }                 from 'react-router-dom';
import useTranslate             from 'app/common/hooks/translate';

const Layout = props => {
    const t                                 = useTranslate();
    const [ s, setState ]                   = useState({
        showPermission: false
    })

    useEffect(() => {
        if (!AuthorizationContext.user.profile.attributes.iys_allowPhone)
            setState({
                showPermission: true
            });
    }, [])

    const togglePermissionModal = () => {
        setState({
            showPermission: !s.showPermission
        });
    }

    const renderPermissions = () => {
        return s.showPermission
            ?   <Permissions closePermissionModal={ () => togglePermissionModal() } />
            :   null
    }

    return (
        <Main>
            { renderPermissions() }
            <ApplicationWrapper 
                screenMode                  = { props.screenMode }
            >
                <ApplicationHeader 
                    togglePermissionModal   = { () => togglePermissionModal() }
                />
                <ApplicationContent
                    screenMode              = { props.screenMode }
                >
                    <div className="application-wrapper-content-container bordered">
                    {
                        props.screenMode
                            ?   <div className="back-to-main">
                                    <Link to="/"><span>{ t('Back_To_Products') }</span></Link>
                                    
                                </div>
                            :  null
                    }                        
                        <div className={ `c-container${!props.screenMode ? ' full w100' : ''}` }>
                            { props.children }
                        </div>
                        {
                            !props.screenMode
                                ?   <ApplicationFooter />
                                :   null
                        }
                    </div>
                    {
                        !props.screenMode
                            ?   <Slider />
                            :   null
                    }
                </ApplicationContent>
            </ApplicationWrapper>
        </Main>
    )
}

export default Layout